<div class="mx-auto px-4">
  <div class="mb-4">
    <p class="titre1 mt-4">
      {{ 'ADMINISTRATION_AVANCEE.TITLE' | translate }}
      <mat-icon class="material-symbols-outlined text-[38px] w-[45px] h-[45px] mt-[5px] mr-[30px] float-right">
        admin_panel_settings
      </mat-icon>
    </p>
  </div>

  <div class="mb-6 max-w-4xl">
    <label class="block text-[#ef4444] mb-2 text-sm font-medium">Action</label>
    <select [(ngModel)]="selectedAction" class="w-full p-2 border rounded">
      @for (action of actions; track action) {
        <option [value]="action.value">
          {{ action.label | translate }}
        </option>
      }
    </select>
  </div>

  <div>
    @switch (selectedAction) {
      @case ('conversion') {
        <app-conversion-comptes-fictifs></app-conversion-comptes-fictifs>
      }
      @case ('forcer_mdp') {
        <app-forcer-mot-passe></app-forcer-mot-passe>
      }
      @case ('deplacer') {
        <app-deplacer-utilisateurs></app-deplacer-utilisateurs>
      }
      @case ('modifier_numero_employe') {
        <app-modifier-numero-employe></app-modifier-numero-employe>
      }
      @case ('remplacer_courriel_existant') {
        <app-remplacer-courriel-existant></app-remplacer-courriel-existant>
      }
      @case ('changer_prenom_nom') {
        <app-changer-prenom-nom></app-changer-prenom-nom>
      }
    }
  </div>
</div>
